import { Select } from 'antd'
import { alphabeticalSort } from 'shared'

interface Option {
  label: string
  value?: number | string
  disabled?: boolean
}

/**
 * @deprecated rework what's using this interface to work with the {@link CIMSSelect} component
 * @expires 2024-04-01
 */
export interface SelectOption {
  label: string | undefined | null
  value?: number | string
  disabled?: boolean
  options?: Option[]
}

/**
 * @deprecated rework what's using this type to work with the {@link CIMSSelect} component
 * @expires 2024-04-01
 */
export type onChange = (
  value: string | number | string[] | number[] | undefined
) => void

/**
 * @deprecated rework what's using this type to work with the {@link CIMSSelect} component
 * @expires 2024-04-01
 */
export type onSelect = (option?: Option | Option[]) => void

/**
 * @deprecated rework what's using this type to work with the {@link CIMSSelect} component
 * @expires 2024-04-01
 */
export type defaultValue = Option['value'] | Option['value'][]

interface SelectorProps {
  options: SelectOption[]
  onSelect?: onSelect
  onChange?: onChange
  multiple?: boolean
  defaultOpen?: boolean
  defaultValue?: defaultValue
  currentValue?: defaultValue
  virtual?: boolean
  loading?: boolean
  disabled?: boolean
  placeholder?: string
  undefinedOption?: Option
  style?: React.CSSProperties
}

/**
 * @deprecated use {@link CIMSSelect}
 * @expires 2024-04-01
 */
export const Selector: React.FC<SelectorProps> = ({
  onSelect,
  onChange,
  options,
  multiple,
  defaultValue,
  defaultOpen,
  virtual,
  loading,
  disabled,
  placeholder,
  style,
  undefinedOption,
  currentValue,
}) => {
  const update = (value?: any, option?: any) => {
    if (onChange !== undefined) onChange(value)
    if (onSelect !== undefined) onSelect(option as Option)
  }
  const _options = options.sort(alphabeticalSort('label'))
  return (
    <Select
      style={{ minWidth: 150, ...style }}
      // WHY CAN'T THEY JUST EXPORT OptionsType, OptionData, or OptionGroupData!?
      // (value: string | number, option: OptionsType | OptionData | OptionGroupData) => void
      onChange={update}
      // once again... EXPORT YOUR DAMN INTERFACES! otherwise I have to do this hacky shit!
      // OptionsType is pretty close to SelectOption and SelectOptionOption
      options={undefinedOption ? [undefinedOption, ..._options] : _options}
      mode={multiple ? 'multiple' : undefined}
      placeholder={placeholder}
      showSearch
      allowClear
      value={currentValue}
      defaultValue={defaultValue}
      defaultOpen={defaultOpen}
      virtual={virtual}
      loading={loading}
      disabled={disabled}
      filterOption={(input, option) => {
        const options = [option?.label?.toString() ?? '', `${option?.value}`]
        return options
          .map((i) => i.toLowerCase())
          .some((i) => i.includes(input.toLowerCase()))
      }}
    />
  )
}
